import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiBase = API_ROUTES.campaignsDashboard;
const initialState = {
    loading: false,
    errorMessage: null,
    data: null,
};
function buildQueryParams(params) {
    const q = new URLSearchParams();
    if (params.startDate)
        q.set('startDate', params.startDate);
    if (params.endDate)
        q.set('endDate', params.endDate);
    if (params.status)
        q.set('status', params.status);
    return q;
}
export const getCampaignDashboard = createAsyncThunk('campaignDashboard/fetch', async (params) => {
    const qs = buildQueryParams(params).toString();
    return axios.get(`${apiBase}${qs ? `?${qs}` : ''}`);
}, { serializeError: serializeAxiosError });
export const campaignDashboardSlice = createSlice({
    name: 'campaignDashboard',
    initialState: initialState,
    reducers: {
        clearCampaignDashboard(state) {
            state.data = null;
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getCampaignDashboard.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
        })
            .addMatcher(isPending(getCampaignDashboard), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getCampaignDashboard), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearCampaignDashboard } = campaignDashboardSlice.actions;
export default campaignDashboardSlice.reducer;
